/**
 * BottomBar.tsx
 * Barre inférieure avec workflow filmstrip et contrôles de vue
 * Design Snapbooth Pro - Dark Mode
 */
import React from 'react';
import { useAppStore } from '../../../services/StateService';

/**
 * Composant BottomBar
 */
export function BottomBar(): React.ReactElement {
  const zoomLevel = useAppStore(state => state.canvas.zoomLevel);
  const setZoomLevel = useAppStore(state => state.setZoomLevel);
  const showSafeZone = useAppStore(state => state.project.safeZoneVisible);
  const setShowSafeZone = useAppStore(state => state.setSafeZoneVisible);

  const handleZoomIn = () => {
    setZoomLevel(Math.min(5, zoomLevel * 1.2));
  };

  const handleZoomOut = () => {
    setZoomLevel(Math.max(0.1, zoomLevel / 1.2));
  };

  const _handleZoomReset = () => {
    setZoomLevel(1);
  };

  return (
    <div className="snapbooth-bottombar">
      {/* View Controls */}
      <div className="view-controls">
        {/* Zoom Controls */}
        <div className="zoom-controls">
          <button
            className="zoom-btn"
            onClick={handleZoomOut}
            title="Zoom arrière"
            aria-label="Zoom arrière"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
              <line x1="8" y1="11" x2="14" y2="11" />
            </svg>
          </button>
          <span className="zoom-level">{Math.round(zoomLevel * 100)}%</span>
          <button
            className="zoom-btn"
            onClick={handleZoomIn}
            title="Zoom avant"
            aria-label="Zoom avant"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
              <line x1="11" y1="8" x2="11" y2="14" />
              <line x1="8" y1="11" x2="14" y2="11" />
            </svg>
          </button>
        </div>

        {/* Toggle Safe Zone */}
        <button
          className={`toggle-safe-zone ${showSafeZone ? 'active' : ''}`}
          onClick={() => setShowSafeZone(!showSafeZone)}
          title="Afficher/masquer la Safe Zone"
          aria-label="Safe Zone"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <rect x="7" y="7" width="10" height="10" />
          </svg>
          <span className="toggle-safe-zone-label">Safe Zone</span>
        </button>
      </div>
    </div>
  );
}

export default BottomBar;
